import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import BeforeAfter from "./BeforeAfter";

/**
 * Galeria "Antes & Depois" com navegação (setas + dots).
 * items: [{ title, subtitle, before, after }]
 */
export default function BeforeAfterGallery({ items = [], compact = false }) {
    const [i, setI] = useState(0);
    if (!items.length) return null;
    const current = items[i];
    const go = (dir) => setI((prev) => (prev + dir + items.length) % items.length);

    return (
        <div className="w-full" data-testid="before-after-gallery">
            <div className="relative">
                <div className="rounded-[2rem] overflow-hidden">
                    <BeforeAfter key={i} before={current.before} after={current.after} alt={current.title} />
                </div>

                {items.length > 1 && (
                    <>
                        <button
                            type="button"
                            onClick={() => go(-1)}
                            aria-label="Anterior"
                            data-testid="gallery-prev"
                            className="absolute left-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/95 backdrop-blur shadow-lg flex items-center justify-center text-[hsl(var(--forest))] hover:bg-white hover:scale-105 transition z-10"
                        >
                            <ChevronLeft className="w-5 h-5" />
                        </button>
                        <button
                            type="button"
                            onClick={() => go(1)}
                            aria-label="Seguinte"
                            data-testid="gallery-next"
                            className="absolute right-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/95 backdrop-blur shadow-lg flex items-center justify-center text-[hsl(var(--forest))] hover:bg-white hover:scale-105 transition z-10"
                        >
                            <ChevronRight className="w-5 h-5" />
                        </button>
                    </>
                )}
            </div>

            <div className={`flex items-center ${compact ? "justify-between mt-4" : "justify-between mt-6"} gap-4`}>
                <div className="min-w-0">
                    <div className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--copper))] mb-1">
                        {String(i + 1).padStart(2, "0")} / {String(items.length).padStart(2, "0")}
                    </div>
                    <div className="font-display font-bold text-lg sm:text-xl truncate" data-testid="gallery-title">
                        {current.title}
                    </div>
                    {current.subtitle && (
                        <div className="text-sm text-[hsl(var(--graphite))]/60 truncate">{current.subtitle}</div>
                    )}
                </div>

                <div className="flex items-center gap-2 flex-shrink-0">
                    {items.map((it, idx) => (
                        <button
                            key={`dot-${it?.title || idx}-${it?.after || idx}`}
                            type="button"
                            onClick={() => setI(idx)}
                            aria-label={`Ir para ${idx + 1}`}
                            data-testid={`gallery-dot-${idx}`}
                            className={`h-1.5 rounded-full transition-all ${
                                idx === i
                                    ? "w-8 bg-[hsl(var(--copper))]"
                                    : "w-4 bg-[hsl(var(--graphite))]/20 hover:bg-[hsl(var(--graphite))]/40"
                            }`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
